module.exports = __webpack_public_path__ + "img/upload-pdf.51afcd64.png";